export const AnalyticsEvent = {
  PAGE_LOAD: 'page_load',
  DISCONNECT: 'disconnect',
  MENU_LANG_CHANGE: 'menu_lang_change',
  MENU_REGION_CHANGE: 'menu_region_change',
  ONBOARDING_CLICK: 'onboarding_click',
  FOOTER_CLICK: 'footer_click',
  MENU_CLICK: 'menu_click',
  LEGAL_CLICK: 'legal_click',
  VOTING_CLICK: 'voting_click',
  CONTESTANT_MODAL: 'contestant_modal',
  CART_CLICK: 'cart_click',
  CHECKOUT_CLICK: 'checkout_click',
  TURNSTILE: 'turnstile',
  PROCESSING_PAYMENT: 'processing_payment',
  THANKYOU: 'thankyou',
} as const

export const analyticsEventValues = Object.values(AnalyticsEvent)

export type AnalyticsEventType =
  (typeof AnalyticsEvent)[keyof typeof AnalyticsEvent]
